var _path, _path2, _path3, _path4, _g, _circle, _path5, _mask, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 113C187 153.885 153.885 187 113 187C72.115 187 39 153.885 39 113C39 72.115 72.115 39 113 39C153.885 39 187 72.115 187 113Z",
    fill: "#F0F1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.316 117H120.684C118.658 117 117 115.412 117 113.471V60.5294C117 58.5882 118.658 57 120.684 57H183.316C185.342 57 187 58.5882 187 60.5294V113.471C187 115.412 185.342 117 183.316 117Z",
    fill: "#7FBEC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117 95.8889L134.132 78.6667C136.342 76.4444 139.842 76.4444 141.868 78.6667L159 95.8889L169.132 85.7037C171.342 83.4815 174.842 83.4815 176.868 85.7037L187 95.8889V113.296C187 115.333 185.342 117 183.316 117H120.684C118.658 117 117 115.333 117 113.296V95.8889Z",
    fill: "#3C8B96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.358 78.0723C165.224 78.0723 168.358 74.9383 168.358 71.0723C168.358 67.2063 165.224 64.0723 161.358 64.0723C157.492 64.0723 154.358 67.2063 154.358 71.0723C154.358 74.9383 157.492 78.0723 161.358 78.0723Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 50C111 48.3431 109.657 47 108 47H45C43.3431 47 42 48.3431 42 50V88C42 89.6569 43.3431 91 45 91H108C109.657 91 111 89.6569 111 88V50Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 69,
    r: 13,
    fill: "#DE6A5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.53 73.0438C73.864 73.46 73 72.9812 73 72.1958V65.8042C73 65.0188 73.864 64.54 74.53 64.9562L79.6432 68.152C80.2699 68.5437 80.2699 69.4563 79.6432 69.848L74.53 73.0438Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 39,
    width: 148,
    height: 148
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 113C187 153.885 153.885 187 113 187C72.115 187 39 153.885 39 113C39 72.115 72.115 39 113 39C153.885 39 187 72.115 187 113Z",
    fill: "#F0F1F2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 100C156 98.3431 154.657 97 153 97H71C69.3431 97 68 98.3431 68 100V218C68 219.657 69.3431 221 71 221H153C154.657 221 156 219.657 156 218V100Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.857 139.233V108.025L78 139.233H108.857Z",
    fill: "#5BA7B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1429 108.024L78.1429 139.231L109 108.024L78.1429 108.024Z",
    fill: "#7FBEC6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 149,
    width: 68,
    height: 6,
    rx: 3,
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 161,
    width: 68,
    height: 6,
    rx: 3,
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 173,
    width: 46,
    height: 6,
    rx: 3,
    fill: "#E8E9EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 37,
    y: 43,
    width: 79,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 63,
    y: 93,
    width: 98,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateMedia);
export default __webpack_public_path__ + "static/media/empty-state-media.d053f39d62246d77f2da8e60043bab8b.svg";
export { ForwardRef as ReactComponent };